import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useEditAssignmentMutation } from '../../features/assignment/assignmentApi';
import useGetUnUsedVideoId from '../../Hooks/useGetUnUsedVideoId';

const AssignmentEditModalContent = ({ data, setOpen }) => {

    const { register, watch, setValue, handleSubmit, formState: { errors } } = useForm();

    const [editAssignment, { isLoading, isError, isSuccess }] = useEditAssignmentMutation()
    const { isLoading: isIdsLoading, isError: isIdsError, uniqIdVideos } = useGetUnUsedVideoId({ extraId: data.video_id, shouldGiveAllId: false })

    useEffect(() => {
        Object.keys(data).forEach(key => {
            setValue(key, data[key])
        })
    }, [uniqIdVideos, data, setValue])


    const onSubmit = (data) => {
        data.totalMark = parseFloat(data.totalMark)
        if (data.video_id) {
            const videoId = parseInt(data.video_id)
            data.video_id = videoId
            const video_title = uniqIdVideos.find(single => single.id === videoId).title
            data.video_title = video_title
        }
        editAssignment(data)
    }

    useEffect(() => {
        if (isSuccess) {
            setOpen(false)
        }
    }, [isSuccess])
    return (
        <div>
            {
                isIdsLoading ? <div className='flex justify-center'>
                    <Loading></Loading>
                </div> : <form onSubmit={handleSubmit(onSubmit)}>
                    <label htmlFor="title">Title:</label>
                    <input className='login-input' type="text" id="title" {...register("title", { required: true })} />
                    <label htmlFor="totalMark">Total Mark</label>
                    <input type="number" className='login-input' id="totalMark" {...register("totalMark", { required: true })} />

                    <label htmlFor="choseID">choose Video</label>
                    {
                        uniqIdVideos.length ? <select  {...register("video_id", { required: true })} id='choseID' defaultValue={undefined} className='block w-full login-input '>
                            <option value={undefined} hidden >Select video</option>
                            {uniqIdVideos.map(single => <option className='my-2' key={single.id} value={single.id}>{single.title}</option>)}
                        </select> :
                            <div className='text-error text-center'>
                                No uniq videos found to add Assignment. No worry you can add letter!
                            </div>
                    }

                    <button disabled={isLoading} className='mt-5 py-2 px-5 rounded-md border border-blue-500' type="submit">Edit</button>
                </form>
            }
        </div>
    );
};

export default AssignmentEditModalContent;